
import gql from 'graphql-tag'
// 查询测试
export const findMember = gql`
  query($memberId: Int!) {
    findMember(
      memberId: $memberId,
    ) {
      id
      nickname
      profilePhoto
      uniqueId
      addresses {
        id
        className
        year
        realname
        phone
        isDefault
        school {
          id
          name
          area {
            id
            mergerName
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`
